import type { WorkflowInputField } from "./workflows-api";

export function orderedWorkflowInputFields(fields: readonly WorkflowInputField[]): WorkflowInputField[] {
  return fields
    .map((field, index) => ({ field, index }))
    .sort((a, b) => (a.field.order ?? a.index) - (b.field.order ?? b.index))
    .map(({ field }) => field);
}

export function initialWorkflowInputValues(fields: readonly WorkflowInputField[], email: string): Record<string, unknown> {
  const values: Record<string, unknown> = {};
  for (const field of fields) {
    if (field.widget === "oneOf") {
      values[field.key] = field.branches?.[0]?.key ?? "";
      for (const branch of field.branches ?? []) Object.assign(values, initialWorkflowInputValues(branch.fields, email));
    } else if (field.widget === "userEmail") values[field.key] = email;
    else if (field.widget === "multiUserEmail") values[field.key] = email ? [email] : [];
    else if (field.type === "boolean") values[field.key] = false;
    else values[field.key] = "";
  }
  return values;
}

/** Fields from inactive oneOf branches must not be submitted with stale values. */
export function activeWorkflowInputFields(fields: readonly WorkflowInputField[], values: Record<string, unknown>): WorkflowInputField[] {
  const result: WorkflowInputField[] = [];
  for (const field of orderedWorkflowInputFields(fields)) {
    result.push(field);
    if (field.widget === "oneOf") {
      const selected = field.branches?.find((branch) => branch.key === values[field.key]) ?? field.branches?.[0];
      if (selected) result.push(...activeWorkflowInputFields(selected.fields, values));
    }
  }
  return result;
}

export function buildWorkflowInput(fields: readonly WorkflowInputField[], values: Record<string, unknown>) {
  const input: Record<string, unknown> = {};
  for (const field of activeWorkflowInputFields(fields, values)) {
    const value = values[field.key];
    if (field.type === "boolean") input[field.key] = value === true;
    else if (field.type === "stringArray") input[field.key] = Array.isArray(value) ? value.filter((item): item is string => typeof item === "string" && !!item.trim()).map((item) => item.trim()) : [];
    else input[field.key] = typeof value === "string" ? value.trim() : "";
  }
  return input;
}
